/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { DeleteCardAction, DeleteWidgetAction } from './actions/DeleteActions';
import { CopyAction, PasteAction } from './actions/CopyPasteActions';
import { DuplicateAction } from './actions/DuplicateAction';
import { ShowAction, HideAction } from './actions/ShowHideActions';
import { CompareAction } from './actions/CompareAction';

/**
 * Models actions which can be applied to one or more cards
 */
class CardActions {
	constructor({ exploreVM, layoutModel }) {
		this.layoutModel = layoutModel;

		const options = { exploreVM, layoutModel };

		this.actionDescriptors = [
			new DeleteCardAction(options),
			new DeleteWidgetAction(options),
			new CopyAction(options),
			new PasteAction(options),
			new DuplicateAction(options),
			new ShowAction(options),
			new HideAction(options),
			new CompareAction(options)
		];
	}

	/**
	 * Get the action with a certain id. The action returned must have list of
	 * cards supplied to it.
	 * @return {object}
	 */
	getAction(id) {
		return this.actionDescriptors.find(
			actionDescriptor => actionDescriptor.getAttributes().id === id
		);
	}

	/**
	 * Get a list of actions appropriate to the supplied cards. The actions
	 * returned will be bound to the supplied `cards`
	 * @param {object[]} cards - card layouts of the cards in question
	 * @return {object[]} array of actions which are applicable to `cards`
	 */
	getActions(cards) {
		return this.actionDescriptors
			.filter(actionDescriptor => actionDescriptor.isEnabled(cards))
			.map(actionDescriptor => (
				{
					action: () => actionDescriptor.action(cards),
					... actionDescriptor.getAttributes()
				}
			));
	}
}

module.exports = CardActions;



// WEBPACK FOOTER //
// ./src/js/components/cards/CardActions.js